import { Action } from 'redux';
type AttrName = keyof AttributeType;

const NumberAttributes: AttrName[] = ['itemId'];

const BooleanAttributes: AttrName[] = ['commentsEnabled', 'enableSave'];

const StringAttributes: AttrName[] = ['css', 'saveLabel'];

export const Attributes: AttrName[] = [
  ...NumberAttributes,
  ...BooleanAttributes,
  ...StringAttributes
];

export interface AttributeType {
  css: 'loaded' | 'error';
  itemId: number;
  commentsEnabled?: boolean;
  enableSave?: boolean;
  saveLabel?: string;
}

type HTMLElementState = AttributeType;

const UPDATE_ELEMENT_STATE = 'UPDATE_ELEMENT_ATTRIBUTE_STATE';
export const updateHTMLElementState = (newState: Partial<HTMLElementState>) => {
  const attrs = {};
  Object.keys(newState).forEach(k => {
    const i = Attributes.map(a => a.toLowerCase()).indexOf(k.toLowerCase());
    if (i >= 0) {
      const val = newState[k];
      const attrName = Attributes[i];
      if (
        val &&
        typeof val != 'number' &&
        NumberAttributes.indexOf(attrName) >= 0
      ) {
        let n = parseInt(val);
        if (isNaN(n)) n = null;
        attrs[attrName] = n;
      } else if (
        val &&
        typeof val != 'boolean' &&
        BooleanAttributes.indexOf(attrName) >= 0
      ) {
        const b = val?.toLowerCase();
        if (b == 'y' || b == 'yes' || b == 't' || b == 'true') {
          attrs[attrName] = true;
        } else if (
          b == 'n' ||
          b == 'no' ||
          b == 'f' ||
          b == 'false'
        ) {
          attrs[attrName] = false;
        }
      } else {
        attrs[attrName] = val;
      }
    }
  });
  return {
    type: UPDATE_ELEMENT_STATE,
    attrs
  };
};

interface AppAction extends Action {
  attrs: Partial<HTMLElementState>;
}

const attrReducer = (
  state: HTMLElementState = {} as HTMLElementState,
  action: AppAction
): HTMLElementState => {
  const { type, attrs } = action;
  switch (type) {
    case UPDATE_ELEMENT_STATE:
      return { ...state, ...attrs };
    default:
      return state;
  }
};

export default attrReducer;
